export default "/_next/static/chunks/fonts/lato-400-italic-516d382b3da7e145024bacf40b3c301e.woff2";